export default "__VITE_ASSET__5aca1ec9__"